/**
 * @namespace PIXI.particles
 */
export { default as ParticleContainer } from './ParticleContainer';
export { default as ParticleRenderer } from './webgl/ParticleRenderer';
